import dayjs from '@/utils/dayjs-instance';

export const createOrderChangeFormatter = (
  timezoneOffset: number = 0
): Record<string, unknown> => ({
  statusName: {
    name: 'status',
    format: (v?: string) => v,
  },
  plannedDate: {
    name: 'planned date',
    format: (v?: string) =>
      v
        ? `${dayjs
            .utc(v)
            .utcOffset(timezoneOffset * 60)
            .format('DD, MMMM HH:mm')}`
        : '',
  },
  plannedDateDuration: {
    name: 'duration',
    format: (v?: number) => `${v ?? 0} minutes`,
  },
  deliveredDate: {
    name: 'deliver date',
    format: (v?: string) =>
      v
        ? `${dayjs
            .utc(v)
            .utcOffset(timezoneOffset * 60)
            .format('DD, MMMM HH:mm')}`
        : '',
  },
  totalCents: {
    name: 'total',
    format: (v?: string) => v,
  },
  driverID: {
    name: 'driver id',
    format: (v?: string) => v,
  },
  warehouseID: {
    name: 'driver id',
    format: (v?: string) => v,
  },
  reasonRefusal: {
    name: 'refuse reason',
    format: (v?: string) => `"${v?.trim() ?? ''}"`,
  },
});

export const orderChangeFormatter = createOrderChangeFormatter(0);

export const orderChangeFormatters = Object.keys(orderChangeFormatter);
